"use strict";

var _toConsumableArray = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listPathFlat = exports.listPathRecursive = exports.bytesToArray = void 0;

var api_1 = require("./api");
/**
 * bytesToArray converts a buffer into <4mb chunks for use with grpc API
 * @param chunk an input Buffer or Uint8Array
 */


function bytesToArray(chunk) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1024 * 1024 * 3;
  var result = [];
  var len = chunk.length;
  var i = 0;

  while (i < len) {
    result.push(chunk.slice(i, i += size));
  }

  return result;
}

exports.bytesToArray = bytesToArray;
/**
 * listPathRecursive returns a nested object of all paths (and info) in a bucket
 */

function listPathRecursive(grpc, bucketKey, path, depth) {
  var currentDepth = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var rootPath, tree, i, obj, dirPath, _yield$listPathRecurs, item;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rootPath = path === '' || path === '.' || path === '/' ? '' : "".concat(path, "/");
            _context.next = 3;
            return api_1.bucketsListPath(grpc, bucketKey, path);

          case 3:
            tree = _context.sent;

            if (!(tree.item && (currentDepth + 1 <= depth || depth === -1))) {
              _context.next = 19;
              break;
            }

            i = 0;

          case 6:
            if (!(i < tree.item.items.length)) {
              _context.next = 19;
              break;
            }

            obj = tree.item.items[i];

            if (obj.isDir) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("continue", 16);

          case 10:
            dirPath = "".concat(rootPath).concat(obj.name);
            _context.next = 13;
            return listPathRecursive(grpc, bucketKey, dirPath, depth, currentDepth + 1);

          case 13:
            _yield$listPathRecurs = _context.sent;
            item = _yield$listPathRecurs.item;

            if (item) {
              tree.item.items[i] = item;
            }

          case 16:
            i++;
            _context.next = 6;
            break;

          case 19:
            return _context.abrupt("return", tree);

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

exports.listPathRecursive = listPathRecursive;

function treeToPaths(tree, path) {
  var dirs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var depth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 5;
  var currentDepth = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var result, _iterator, _step, item, newPath, downtree;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            result = [];
            _iterator = _createForOfIteratorHelper(tree);
            _context2.prev = 2;

            _iterator.s();

          case 4:
            if ((_step = _iterator.n()).done) {
              _context2.next = 15;
              break;
            }

            item = _step.value;
            newPath = path === '' ? "".concat(item.name) : "".concat(path, "/").concat(item.name);
            if (dirs || !item.isDir) result.push(newPath);

            if (!(item.isDir && (currentDepth < depth || depth === -1))) {
              _context2.next = 13;
              break;
            }

            _context2.next = 11;
            return treeToPaths(item.items, newPath, dirs, depth, currentDepth + 1);

          case 11:
            downtree = _context2.sent;
            result.push.apply(result, _toConsumableArray(downtree));

          case 13:
            _context2.next = 4;
            break;

          case 15:
            _context2.next = 20;
            break;

          case 17:
            _context2.prev = 17;
            _context2.t0 = _context2["catch"](2);

            _iterator.e(_context2.t0);

          case 20:
            _context2.prev = 20;

            _iterator.f();

            return _context2.finish(20);

          case 23:
            return _context2.abrupt("return", result);

          case 24:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 17, 20, 23]]);
  }));
}
/**
 * listPathFlat returns a string array of all paths in a bucket
 */


function listPathFlat(grpc, bucketKey, path, dirs, depth) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var tree;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return listPathRecursive(grpc, bucketKey, path, depth);

          case 2:
            tree = _context3.sent;

            if (tree.item) {
              _context3.next = 5;
              break;
            }

            return _context3.abrupt("return", []);

          case 5:
            return _context3.abrupt("return", treeToPaths(tree.item.items, path, dirs));

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
}

exports.listPathFlat = listPathFlat;